(function () {
  'use strict';


  /* ==========================================================
     PREVENT DOUBLE INITIALIZATION
     ========================================================== */

  if (window.ScotlandTitleFloatingCartLoaded) {
    return;
  }

  window.ScotlandTitleFloatingCartLoaded = true;


  /* ==========================================================
     INITIALIZE
     ========================================================== */

  function initFloatingCart() {

    var floatingCart =
      document.getElementById('st-floating-cart');

    var button =
      document.getElementById('st-floating-cart-button');

    var countElement =
      document.getElementById('st-floating-cart-count');

    var totalElement =
      document.getElementById('st-floating-cart-total');


    if (
      !floatingCart ||
      !button ||
      !countElement ||
      !totalElement
    ) {
      return;
    }


    /*
     * Make absolutely sure that the floating cart is a
     * direct child of <body>.
     *
     * This avoids transformed/positioned theme containers
     * interfering with position: fixed.
     */



    var shopRoot = '/';


    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      shopRoot = window.Shopify.routes.root;
    }


    var updateTimer = null;


    /* ========================================================
       MONEY
       ======================================================== */

    function formatMoney(cents, currency) {

      var amount =
        Number(cents || 0) / 100;


      try {

        return new Intl.NumberFormat(
          document.documentElement.lang || 'en',
          {
            style: 'currency',
            currency: currency || 'EUR'
          }
        ).format(amount);

      } catch (error) {

        return amount.toFixed(2);

      }

    }


    /* ========================================================
       GET CURRENT CART
       ======================================================== */

    function updateFloatingCart() {

      fetch(
        shopRoot + 'cart.js',
        {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json'
          }
        }
      )
      .then(function (response) {

        if (!response.ok) {
          throw new Error('Unable to retrieve Shopify cart.');
        }

        return response.json();

      })
      .then(function (cart) {

        var itemCount =
          Number(cart.item_count || 0);


        /*
         * Empty cart
         */

        if (itemCount === 0) {

          floatingCart.classList.remove(
            'st-floating-cart--visible'
          );

          floatingCart.setAttribute(
            'aria-hidden',
            'true'
          );

          if (
            typeof floatingCart.hidePopover === 'function' &&
            floatingCart.matches(':popover-open')
          ) {
            floatingCart.hidePopover();
          }

          countElement.textContent =
            '0 items';

          totalElement.textContent =
            '';

          return;
        }


        /*
         * Cart contains products
         */

        countElement.textContent =
          itemCount === 1
            ? '1 item'
            : itemCount + ' items';


        totalElement.textContent =
          formatMoney(
            cart.total_price,
            cart.currency
          );


          if (
            typeof floatingCart.showPopover === 'function' &&
            !floatingCart.matches(':popover-open')
          ) {
            floatingCart.showPopover();
          }

          floatingCart.classList.add(
            'st-floating-cart--visible'
          );

          floatingCart.setAttribute(
            'aria-hidden',
            'false'
          );

      })
      .catch(function (error) {

        console.warn(
          'Scotland Title floating cart:',
          error
        );

      });

    }


    /* ========================================================
       SCHEDULE UPDATE
       ======================================================== */

    function scheduleUpdate(delay) {

      clearTimeout(updateTimer);

      updateTimer =
        setTimeout(
          updateFloatingCart,
          typeof delay === 'number'
            ? delay
            : 150
        );

    }


    /* ========================================================
       OPEN THE THEME'S EXISTING CART DRAWER
       ======================================================== */

    function openCartDrawer() {

      var drawer =
        document.querySelector('cart-drawer');


      if (
        drawer &&
        typeof drawer.open === 'function'
      ) {

        drawer.open();

        return;

      }


      /*
       * Fallback if Shopify's cart-drawer custom element
       * hasn't initialized yet.
       */

      var cartTrigger =
        document.querySelector(
          '[aria-controls="CartDrawer"]'
        );


      if (cartTrigger) {

        cartTrigger.click();

        return;

      }


      /*
       * Final fallback
       */

      window.location.href =
        shopRoot + 'cart';

    }


    /* ========================================================
       FLOATING BAR CLICK
       ======================================================== */

    button.addEventListener(
      'click',
      function () {
        openCartDrawer();
      }
    );


    /* ========================================================
       SHOPIFY STANDARD CART EVENTS
       ======================================================== */

    document.addEventListener(
      'shopify:cart:lines-update',
      function () {
        scheduleUpdate(100);
      }
    );


    document.addEventListener(
      'shopify:cart:update',
      function () {
        scheduleUpdate(100);
      }
    );


    /* ========================================================
       FETCH INTERCEPTION

       Many Shopify themes add/change cart items through fetch().
       Capture the URL BEFORE calling fetch so the callback
       always knows which request changed the cart.
       ======================================================== */

    if (!window.ScotlandTitleOriginalFetch) {

      window.ScotlandTitleOriginalFetch =
        window.fetch;


      window.fetch =
        function () {

          var args =
            Array.prototype.slice.call(arguments);

          var request =
            args[0];

          var url = '';


          if (typeof request === 'string') {

            url = request;

          } else if (
            request &&
            request.url
          ) {

            url = request.url;

          }


          return window.ScotlandTitleOriginalFetch
            .apply(this, args)
            .then(function (response) {

              if (
                url.indexOf('/cart/add') !== -1 ||
                url.indexOf('/cart/change') !== -1 ||
                url.indexOf('/cart/update') !== -1 ||
                url.indexOf('/cart/clear') !== -1
              ) {

                /*
                 * Give the theme a moment to finish its own
                 * cart processing first.
                 */

                scheduleUpdate(200);

              }


              return response;

            });

        };

    }


    /* ========================================================
       XMLHttpRequest COMPATIBILITY

       Some older/custom Shopify theme code may still use XHR.
       ======================================================== */

    if (!window.ScotlandTitleXHRPatched) {

      window.ScotlandTitleXHRPatched = true;


      var originalOpen =
        XMLHttpRequest.prototype.open;

      var originalSend =
        XMLHttpRequest.prototype.send;


      XMLHttpRequest.prototype.open =
        function (
          method,
          url
        ) {

          this._stCartRequestUrl =
            typeof url === 'string'
              ? url
              : '';

          return originalOpen.apply(
            this,
            arguments
          );

        };


      XMLHttpRequest.prototype.send =
        function () {

          var xhr =
            this;


          if (
            xhr._stCartRequestUrl &&
            (
              xhr._stCartRequestUrl.indexOf('/cart/add') !== -1 ||
              xhr._stCartRequestUrl.indexOf('/cart/change') !== -1 ||
              xhr._stCartRequestUrl.indexOf('/cart/update') !== -1 ||
              xhr._stCartRequestUrl.indexOf('/cart/clear') !== -1
            )
          ) {

            xhr.addEventListener(
              'loadend',
              function () {
                scheduleUpdate(200);
              }
            );

          }


          return originalSend.apply(
            this,
            arguments
          );

        };

    }
    /* ========================================================
       RESTORE PAGE AFTER CART DRAWER CLOSE

       Dawn locks body scrolling while the drawer is open.
       This ensures that state is fully restored after closing.
       ======================================================== */

    var nativeCartDrawer =
      document.querySelector('cart-drawer');


    function restorePageAfterDrawerClose() {

      document.body.classList.remove(
        'overflow-hidden'
      );

      document.documentElement.classList.remove(
        'overflow-hidden'
      );


      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.body.style.marginRight = '';
      document.body.style.width = '';
      document.body.style.position = '';
      document.body.style.left = '';
      document.body.style.right = '';


      document.documentElement.style.overflow = '';
      document.documentElement.style.paddingRight = '';

    }


    if (nativeCartDrawer) {

      /*
       * Watch the native drawer's active class.
       *
       * Shopify adds "active" when opening and removes it
       * when the drawer closes.
       */

      var cartDrawerObserver =
        new MutationObserver(
          function () {

            if (
              !nativeCartDrawer.classList.contains(
                'active'
              )
            ) {

              /*
               * Allow Shopify's own close() to finish first.
               */

              setTimeout(
                restorePageAfterDrawerClose,
                50
              );

            }

          }
        );


      cartDrawerObserver.observe(
        nativeCartDrawer,
        {
          attributes: true,
          attributeFilter: ['class']
        }
      );


      /*
       * Extra safety for the native close button.
       */

      document.addEventListener(
        'click',
        function (event) {

          if (
            event.target.closest(
              'cart-drawer .drawer__close'
            )
          ) {

            setTimeout(
              restorePageAfterDrawerClose,
              100
            );

          }

        }
      );

    }

    /* ========================================================
       INITIAL STATE
       ======================================================== */

    updateFloatingCart();

  }


  /* ==========================================================
     RUN AFTER DOM EXISTS
     ========================================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initFloatingCart
    );

  } else {

    initFloatingCart();

  }

})();